<template>
  <div class="cc-info-box">
    <span>{{ title }}</span>
    <v-icon>mdi-information</v-icon>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: ["title"],
  watch: {},
});
</script>
<style scoped lang="scss"></style>
